import { Box, Container, List, ListItem, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ProofButton } from '../../../ui/button/ProofButton';
import LinkLoader, { IncomeType } from '../../plaid/LinkLoader';
import { useUpload } from '.';
import palette from '../../../ui/palette';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';

export default function DocUploadInstructions() {
  const { t } = useTranslation();
  const { goTo } = useUpload();

  return (
    <Container maxWidth="xs" disableGutters sx={{ py: { xs: 2, md: 3 } }}>
      <Typography variant="h2" textAlign="center" sx={{ fontWeight: 500, mb: 1 }}>
        {t('verification.type.document.uploadHint')}
      </Typography>
      <Typography variant="body2" textAlign="center" sx={{ mb: 3, color: palette.grey[60] }}>
        {t('verification.type.document.pdfOnlyHint')}
      </Typography>

      <Typography variant="body1" sx={{ mb: 2 }}>
        {t('verification.type.document.uploadSuggest')}
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 2, mb: 3 }}>
        <Box sx={{ flex: 1 }}>
          <LinkLoader
            buttonText={t('verification.type.document.bankContinue')}
            income={true}
            incomeType={IncomeType.Bank}
            startIcon={<AccountBalanceIcon />}
          />
        </Box>
        <Box sx={{ flex: 1 }}>
          <LinkLoader
            buttonText={t('verification.type.document.payrollContinue')}
            income={true}
            incomeType={IncomeType.Payroll}
            startIcon={<WorkOutlineIcon />}
          />
        </Box>
      </Box>

      <Typography variant="body1" sx={{ mb: 2 }}>
        {t('verification.type.document.manualUploadHint')}
      </Typography>

      <List sx={{ border: '1px solid #ededed', borderRadius: 2, boxShadow: '0 1px 4px 0 rgba(118,118,118,.08)', mb: 3 }}>
        <ListItem sx={{ display: 'flex', gap: 1 }}>
          <Typography sx={{ fontWeight: 700 }}>1.</Typography>
          <Typography sx={{ fontWeight: 500 }}>{t('verification.type.document.docPaystubs')}</Typography>
        </ListItem>
        <ListItem sx={{ display: 'flex', gap: 1 }}>
          <Typography sx={{ fontWeight: 700 }}>2.</Typography>
          <Typography sx={{ fontWeight: 500 }}>{t('verification.type.document.docOfferLetter')}</Typography>
        </ListItem>
        <ListItem sx={{ display: 'flex', gap: 1 }}>
          <Typography sx={{ fontWeight: 700 }}>3.</Typography>
          <Typography sx={{ fontWeight: 500 }}>{t('verification.type.document.docBankStatements')}</Typography>
        </ListItem>
      </List>

      <ProofButton variant="contained" fullWidth onClick={() => goTo('select')}>
        {t('verification.type.document.uploadDocumentsButton')}
      </ProofButton>
    </Container>
  );
}
